<template>
	<select :id="id" :disabled="disabled" :name="name" ref="cliente"></select>
</template>
<script>
	export default {
		props: ['value', 'disabled', 'id', 'name', 'title', 'corporacion'],

		mounted(){
			var vm = this
			var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
            $(this.$el)
			.val(this.value)
			.select2({
		        ajax: { 
					url: crm.url+"/api/catalogos/getClientes",
					type: "get",
					dataType: 'json',
					delay: 250,
					language: 'es',
					data: function (params) {
						return {
							api_token: crm.token,
							term: params.term,
							CODIGO_CORPORACION: vm.corporacionValue,
							page: params.page || 1
						};
					},
					processResults: function (data) {
						data.page = data.page || 1;

						return {
					    	results: data.items,
					    	pagination: {
			                	more: data.pagination
			                }
						};
					},

					transport: function (params, success, failure) {
						var $request = $.ajax(params);

						$request.then(success);
						$request.fail(failure);

						return $request;
					},

		        	cache: true,
		        	placeholder: "-- Seleccionar --",
		        	allowClear: true,
		        	templateSelection: function(data){
                        if (!data.element) {
                          return data.text;
                        }

                        var $element = $(data.element);

                        if(typeof($element[0].dataset.bold) != "undefined"){
                            var $wrapper = $('<span></span>');

                            var $bold = $element[0].dataset.bold;
                            var $html = '<strong>'+$bold+'</strong>';

                            $wrapper.addClass($element[0].className);

                            $wrapper.text(data.text);

                            $wrapper.prepend($html);

                            return $wrapper;
                        }

                        if(typeof($element[0].dataset.icon) != "undefined"){
                            var $wrapper = $('<span></span>');

                            var $icon = $element[0].dataset.icon;
                            var $html = '<i class="'+$icon+'"></i>';

                            $wrapper.addClass($element[0].className);

                            $wrapper.text(data.text);

                            $wrapper.prepend($html);

                            return $wrapper;
                        }

                        if(typeof($element[0].dataset.image) != "undefined"){
                            var $wrapper = $('<span></span>');

                            var $image = $element[0].dataset.image;
                            var $html = '<img class="shadow" style="max-width: 30%;" src="'+$image+'" height="25px" />';

                            $wrapper.addClass($element[0].className);

                            $wrapper.text(data.text);

                            $wrapper.prepend($html);

                            return $wrapper;
                        }

                        return data.text;
                    },
                    templateResult: function (data) {
                        if (!data.element) {
                          return data.text;
                        }

                        var $element = $(data.element);

                        if(typeof($element[0].dataset.porcentaje) != "undefined"){
                            var $porcentaje = $element[0].dataset.porcentaje;
                            var $html = '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated bg-navy" role="progressbar" style="width: '+ $porcentaje +'%;" aria-valuenow="'+$porcentaje+'" aria-valuemin="0" aria-valuemax="100"></div></div>';

                            var $wrapper = $('<span></span>');

                            $wrapper.addClass($element[0].className);

                            $wrapper.text(data.text);
                            $wrapper.append($html);

                            return $wrapper;
                        }

                        if(typeof($element[0].dataset.bold) != "undefined"){
                            var $wrapper = $('<span></span>');

                            var $bold = $element[0].dataset.bold;
                            var $html = '<strong>'+$bold+'</strong>';

                            $wrapper.addClass($element[0].className);

                            $wrapper.text(data.text);

                            $wrapper.prepend($html);

                            return $wrapper;
                        }

                        if(typeof($element[0].dataset.icon) != "undefined"){
                            var $wrapper = $('<span></span>');

                            var $icon = $element[0].dataset.icon;
                            var $html = '<i class="'+$icon+'"></i>';

                            $wrapper.addClass($element[0].className);

                            $wrapper.text(data.text);

                            $wrapper.prepend($html);

                            return $wrapper;
                        }

                        if(typeof($element[0].dataset.image) != "undefined"){
                            var $wrapper = $('<span></span>');

                            var $image = $element[0].dataset.image;
                            var $html = '<img class="shadow" style="max-width: 30%;" src="'+$image+'" height="25px" />';

                            $wrapper.addClass($element[0].className);

                            $wrapper.text(data.text);

                            $wrapper.prepend($html);

                            return $wrapper;
                        }

                        return data.text;
                    }
		    	}
		    })
            .on('change', function () {
                vm.$emit('input', this.value)
            });
            
		},

		created(){
			this.loadData();
		},

		methods: {
			loadData: function(){
				const client = this.clienteValue
				if (client) {
					// Fetch the preselected item, and add to the control
					axios.get('/api/catalogos/getClientes', {
						params: {
							CODIGO_CLIENTE: client
						}
					})
					.then(response => {
						// create the option and append to Select2
					    var option = new Option(response.data.items[0].text, response.data.items[0].id, true, true);
					    $(this.$el).append(option).trigger('change');

					    // manually trigger the `select2:select` event
						$(this.$el).trigger({
						    type: 'select2:select',
						    params: {
						        data: response.data.items[0]
						    }
						});
					})
				}
			}
		},

		data(){
			return {
				clientes: [],
			}
		},

		computed: {
			corporacionValue: function(){
				return this.corporacion
			},

			clienteValue: function(){
				return this.value
			}
		},

		watch: {
            value: function (value) {
                $(this.$el).val(value).trigger('change');
                this.loadData()
            },

            disabled: function(value){
            	$(this.$el).attr('disabled', value);
            	if (value) {
            		$(this.$el).find('a').hide();
            	}else{
            		$(this.$el).find('a').show();
            	}
            },

            id: function(value){
            	$(this.$el).attr('id', value);
            	$(this.$el).children('label').attr('for', value);
            },
        },
        
        destroyed: function () {
            $(this.$el).off().select2('destroy')
        }
	}
</script>